<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{ $t('学生管理') }}</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="primary"
          icon="el-icon-plus"
          @click="handleAdd"
        >
          {{ $t('添加学生') }}
        </el-button>
      </div>

      <div class="filter-container">
        <el-row :gutter="10">
          <el-col :md="6" :sm="8">
            <div>
              <el-input v-model="listQuery.searchword" :placeholder="$t('请输入学生姓名、手机号或留言详情')" clearable class="filter-item" @keyup.enter.native="handleFilter" />
            </div>
          </el-col>
          <el-col :md="5" :sm="7">
            <div>
              <el-date-picker v-model="listQuery.start_time" format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择开始时间" clearable style="width: 100%;" class="filter-item" />
            </div>
          </el-col>
          <el-col :md="5" :sm="7">
            <div>
              <el-date-picker v-model="listQuery.end_time" format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择结束时间" clearable style="width: 100%;" class="filter-item" />
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :md="3" :sm="3">
            <div>
              <el-button
                v-waves
                class="filter-item"
                type="danger"
                style="width:100%;"
                :disabled="!showDeletebtn"
                @click="handleDeleteList"
              >
                {{ $t('删除选中') }}
              </el-button>
            </div>
          </el-col>
          <el-col :md="3" :sm="3">
            <div>
              <el-select v-model="listQuery.order" class="filter-item" style="width: 100%;" @change="handleFilter">
                <el-option v-for="item in sortOptions" :key="item.key" :label="item.label" :value="item.key" />
              </el-select>
            </div>
          </el-col>
          <el-col :md="3" :sm="3">
            <div>
              <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" style="width: 100%;" @click="handleFilter">
                {{ $t('搜索') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-table
        ref="studentTable"
        v-loading="listLoading"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        :data="list"
        class="border-gray"
        fit
        highlight-current-row
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        />

        <el-table-column width="80px" align="left" :label="$t('ID')">
          <template slot-scope="{row}">
            <span>{{ row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" :label="$t('姓名')">
          <template slot-scope="{row}">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column width="80px" align="center" :label="$t('年龄')">
          <template slot-scope="{row}">
            <span>{{ row.age }}</span>
          </template>
        </el-table-column>

        <el-table-column width="80px" align="center" :label="$t('性别')">
          <template slot-scope="{row}">
            <el-tag :type="row.gender == 1 ? 'primary' : 'success'" size="mini">
              {{ row.gender == 1 ? $t('男') : $t('女') }}
            </el-tag>
          </template>
        </el-table-column> -->

        <el-table-column min-width="120px" :label="$t('手机号')">
          <template slot-scope="{row}">
            <span>{{ row.phone || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" :label="$t('微信号')">
          <template slot-scope="{row}">
            <span>{{ row.wechat || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="200px" :label="$t('留言详情')">
          <template slot-scope="{row}">
            <span>{{ row.message_detail || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="120px" :label="$t('意向度')">
          <template slot-scope="{row}">
            <span>{{ row.intent || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="100px" :label="$t('反馈状态')">
          <template slot-scope="{row}">
            <el-tag :type="getValidFlagType(row.valid_flag_code)" size="mini">
              {{ row.valid_flag_code || '-' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column width="170px" align="left" :label="$t('创建时间')">
          <template slot-scope="scope">
            <span class="text-muted">
              <i class="el-icon-time" />&nbsp;
              {{ scope.row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}
            </span>
          </template>
        </el-table-column>

        <el-table-column class-name="status-col" :label="$t('状态')" width="70">
          <template slot-scope="{row}">
            <el-tag :type="row.status | statusFilter" size="mini">
              {{ (row.status == 1) ? $t('启用') : $t('禁用') }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('操作')" width="280">
          <template slot-scope="scope">
            <el-button
              v-waves
              :loading="scope.row.id == loading.update"
              :disabled="!checkPermission(['larke-admin.ext.student.index'])"
              type="warning"
              size="mini"
              icon="el-icon-refresh"
              @click="handleUpdate(scope.$index, scope.row)"
            >
              {{ $t('更新') }}
            </el-button>

            <el-button
              v-waves
              :loading="scope.row.id == loading.detail"
              :disabled="!checkPermission(['larke-admin.ext.student.detail'])"
              type="info"
              size="mini"
              icon="el-icon-info"
              @click="handleDetail(scope.$index, scope.row)"
            >
              {{ $t('详情') }}
            </el-button>

            <!-- <el-button
              v-waves
              v-permission="['larke-admin.ext.student.delete']"
              :loading="scope.row.id == loading.delete"
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="handleDelete(scope.$index, scope.row)"
            >
              {{ $t('删除') }}
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </el-card>

    <!-- 学生详情对话框 -->
    <el-dialog
      :title="$t('学生详情')"
      :visible.sync="detail.dialogVisible"
    >
      <detail :data="detail.data" />
    </el-dialog>

    <!-- 添加学生对话框 -->
    <el-dialog
      :title="$t('添加学生')"
      :visible.sync="add.dialogVisible"
      width="600px"
    >
      <el-form ref="addForm" :model="add.form" :rules="add.rules" label-width="100px">
        <el-form-item :label="$t('姓名')" prop="name">
          <el-input v-model="add.form.name" :placeholder="$t('请输入学生姓名')" />
        </el-form-item>

        <el-form-item :label="$t('手机号')" prop="phone">
          <el-input v-model="add.form.phone" :placeholder="$t('请输入手机号')" />
        </el-form-item>

        <el-form-item :label="$t('微信号')" prop="wechat">
          <el-input v-model="add.form.wechat" :placeholder="$t('请输入微信号')" />
        </el-form-item>

        <el-form-item :label="$t('留言详情')">
          <el-input
            v-model="add.form.message_detail"
            type="textarea"
            :rows="4"
            :placeholder="$t('请输入留言详情（可选）')"
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="add.dialogVisible = false">{{ $t('取消') }}</el-button>
        <el-button type="primary" :loading="add.loading" @click="handleAddSubmit">{{ $t('确定') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import waves from '@/directive/waves' // waves directive
import permission from '@/directive/permission/index.js' // 权限判断指令
import checkPermission from '@/utils/permission' // 权限判断函数
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import Detail from '@/components/Larke/Detail'
import {
  getList,
  getDetail,
  createStudent,
  deleteData,
  updateStudent
} from '../api/index'

export default {
  name: 'StudentIndex',
  components: { Pagination, Detail },
  directives: { waves, permission },
  filters: {
    statusFilter(status) {
      const statusMap = {
        1: 'success',
        0: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        searchword: '',
        start_time: '',
        end_time: '',
        order: 'create_time__DESC',
        page: 1,
        limit: 20
      },
      sortOptions: [
        { key: 'create_time__ASC', label: '正序' },
        { key: 'create_time__DESC', label: '倒叙' }
      ],
      detail: {
        dialogVisible: false,
        data: []
      },
      add: {
        dialogVisible: false,
        loading: false,
        form: {
          name: '',
          student_no: '',
          age: 0,
          gender: 1,
          class: '',
          phone: '',
          wechat: '',
          email: '',
          message_detail: ''
        },
        rules: {
          name: [
            { required: true, message: this.$t('请输入学生姓名'), trigger: 'blur' }
          ],
          phone: [
            {
              validator: (rule, value, callback) => {
                if (!value && !this.add.form.wechat) {
                  callback(new Error(this.$t('手机号和微信号必须填写其中一个')))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ],
          wechat: [
            {
              validator: (rule, value, callback) => {
                if (!value && !this.add.form.phone) {
                  callback(new Error(this.$t('手机号和微信号必须填写其中一个')))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ]
        }
      },
      selectedData: [],
      showDeletebtn: false,
      loading: {
        detail: '',
        delete: '',
        update: ''
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    checkPermission,
    getList() {
      this.listLoading = true
      getList({
        searchword: this.listQuery.searchword,
        start_time: this.listQuery.start_time,
        end_time: this.listQuery.end_time,
        order: this.listQuery.order,
        start: (this.listQuery.page - 1) * this.listQuery.limit,
        limit: this.listQuery.limit
      }).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSelectionChange(data, key) {
      this.selectedData = []
      data.forEach(element => {
        this.selectedData.push(element.id)
      })

      if (this.selectedData.length > 0) {
        this.showDeletebtn = true
      } else {
        this.showDeletebtn = false
      }
    },
    handleAdd() {
      this.add.dialogVisible = true
      this.resetAddForm()
    },
    resetAddForm() {
      this.add.form = {
        name: '',
        student_no: '',
        age: 0,
        gender: 1,
        class: '',
        phone: '',
        wechat: '',
        email: '',
        message_detail: ''
      }
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate()
      }
    },
    handleAddSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.add.loading = true
          createStudent(this.add.form).then(response => {
            this.add.loading = false
            this.add.dialogVisible = false
            this.getList()
            this.$message({
              message: response.message,
              type: 'success',
              duration: 3 * 1000
            })
          }).catch(() => {
            this.add.loading = false
          })
        }
      })
    },
    handleDetail(index, row) {
      this.loading.detail = row.id

      getDetail(row.id).then((res) => {
        this.detail.dialogVisible = true
        const data = res.data

        this.loading.detail = ''

        this.detail.data = [
          {
            name: this.$t('ID'),
            content: data.id,
            type: 'text'
          },
          {
            name: this.$t('姓名'),
            content: data.name,
            type: 'text'
          },
          {
            name: this.$t('年龄'),
            content: data.age,
            type: 'text'
          },
          {
            name: this.$t('性别'),
            content: data.gender === 1 ? this.$t('男') : this.$t('女'),
            type: 'text'
          },
          {
            name: this.$t('手机号'),
            content: data.phone || '-',
            type: 'text'
          },
          {
            name: this.$t('微信号'),
            content: data.wechat || '-',
            type: 'text'
          },
          {
            name: this.$t('留言详情'),
            content: data.message_detail || '-',
            type: 'text'
          },
          {
            name: this.$t('意向度'),
            content: data.intent || '-',
            type: 'text'
          },
          {
            name: this.$t('反馈状态'),
            content: data.valid_flag_code || '-',
            type: 'text'
          },
          {
            name: this.$t('创建时间'),
            content: data.create_time,
            type: 'time'
          },
          {
            name: this.$t('状态'),
            content: data.status + '',
            type: 'boolen'
          }
        ]
      }).catch(() => {
        this.loading.detail = ''
      })
    },
    handleDelete(index, row) {
      this.$confirm(this.$t('确认要删除该学生吗？'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning'
      }).then(() => {
        this.loading.delete = row.id

        deleteData(row.id).then(res => {
          this.loading.delete = ''
          this.list.splice(index, 1)

          this.$message({
            message: res.message,
            type: 'success',
            duration: 3 * 1000
          })
        }).catch(() => {
          this.loading.delete = ''
        })
      }).catch(() => {})
    },
    handleDeleteList() {
      this.$confirm(this.$t('确认要删除选中的学生吗？'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning'
      }).then(() => {
        if (this.selectedData.length < 1) {
          this.$message({
            message: this.$t('请选择要删除的学生'),
            type: 'error',
            duration: 3 * 1000
          })
          return
        }

        this.$message({
          message: this.$t('删除选择的学生成功'),
          type: 'success',
          duration: 3 * 1000,
          onClose() {
            for (let i = this.list.length - 1; i >= 0; i--) {
              if (this.selectedData.includes(this.list[i].id)) {
                this.list.splice(i, 1)
              }
            }
          }
        })
      }).catch(() => {
        // 用户取消删除
      })
    },
    handleUpdate(index, row) {
      this.loading.update = row.id
      updateStudent(row.id).then(response => {
        this.loading.update = ''
        this.getList() // 刷新列表
        this.$message({
          message: response.message,
          type: 'success',
          duration: 3 * 1000
        })
      }).catch(() => {
        this.loading.update = ''
      })
    },
    getValidFlagType(validFlagCode) {
      if (!validFlagCode) return 'info'
      const typeMap = {
        '未反馈': 'warning',
        '已反馈': 'success',
        '不符合报考条件': 'danger',
        '正在通话中': 'info'
      }
      return typeMap[validFlagCode] || 'info'
    }
  }
}
</script>

<style scoped>
.pagination-container {
  padding: 5px 2px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
</style>
